export default "<div class=\"rtf {{#if moduleTable}} rtf-rich-table {{/if}}\">\r\n  {{{content}}}\r\n</div>\r\n"